import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {InvitationDetails} from '../../model/invitation-details.model';
import {InvitationService} from '../../service/invitation.service';

@Injectable()
export class InvitationResolver implements Resolve<{ invitationDetails: InvitationDetails, inviteId: string }> {
    constructor(private invitationService: InvitationService) {
    }

    public async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Promise<{ invitationDetails: InvitationDetails, inviteId: string }> {
        const inviteId = route.params.id;
        const invitationDetails = await this.invitationService.getMinimalInvitationDetails(inviteId);
        return {invitationDetails, inviteId};
    }
}
